import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Dot = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <circle
        cx='12'
        cy='12'
        r='4'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <circle cx='12' cy='12' r='4' fill='currentColor' />
    )}
  </IconBase>
);
